var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 39 38"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 19.5,
  cy: 18.999,
  r: 17.417,
  fill: "#8C919F"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.656,
  d: "M24.457 14.598a.35.35 0 1 1 0-.7M24.457 14.598a.35.35 0 1 0 0-.7"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.417,
  d: "M11 14.143a3.643 3.643 0 0 1 3.643-3.643h9.714A3.643 3.643 0 0 1 28 14.143v9.714a3.643 3.643 0 0 1-3.643 3.643h-9.714A3.643 3.643 0 0 1 11 23.857z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.417,
  d: "M15.637 19a3.863 3.863 0 1 0 7.726 0 3.863 3.863 0 0 0-7.726 0"
})));
export default SvgInstagram;